<template>
    <div class="confirm-step-box">
        <div class="confirm-item" v-for="(item, index) in stepList" :key="index">
            <div class="confirm-item-head">
                <div class="confirm-item-head-line"></div>
                <div class="confirm-item-head-text">
                    <el-image
                        class="confirm-item-head-img"
                        v-if="item.type == 1 || item.type == 2"
                        :src="require('@/assets/img/approval_user.png')"
                    ></el-image>
                    <el-image class="confirm-item-head-img" v-else :src="require('@/assets/img/approval_copy.png')"></el-image>
                </div>
            </div>
            <div class="confirm-item-content">
                <div class="item-content-head">
                    <div class="item-content-head-text">{{ item.type == 1 || item.type == 2 ? '审批人' : '抄送人' }}</div>
                </div>
                <div v-if="item.type == 1">
                    <div class="item-content-main">
                        <div class="content-main-head">
                            <div class="main-head-text">
                                <div class="user-box">
                                    <el-image class="avatar" :src="require('@/assets/img/logo_1024.png')"></el-image>
                                    <div>{{ item.auditor.realname }}</div>
                                </div>
                            </div>
                            <div class="main-head-more" v-if="item.audit.status != undefined">
                                <span :style="{ color: status[item.audit.status].color }">{{ status[item.audit.status].title }}</span>
                                <span style="margin-left: 10px">{{ item.audit.update_time }}</span>
                            </div>
                        </div>
                        <div class="user-content" v-if="item.audit.content && item.audit.content != ''">审核内容：{{ item.audit.content }}</div>

                        <div class="comment-box" v-for="(comment, index) in item.comments" :key="index">
                            <div class="comment-head">
                                <div class="comment-head-title">
                                    <span>{{ comment.realname }}</span
                                    >添加了评论
                                </div>
                                <div class="comment-head-more">{{ comment.create_time }}</div>
                            </div>
                            <div class="comment-head-content">评论内容：{{ comment.content }}</div>
                            <div class="comment-image-box">
                                <el-image
                                    class="comment-image"
                                    v-for="(img, index) in comment.images"
                                    :key="index"
                                    :src="img"
                                    :preview-src-list="comment.images"
                                >
                                </el-image>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="item.type == 2">
                    <div class="item-content-main">
                        <div class="content-main-head">
                            <div class="main-head-text" v-for="(user, index) in item.checker" :key="index">
                                <div class="user-box">
                                    <el-image class="avatar" :src="require('@/assets/img/logo_1024.png')"></el-image>
                                    <div>{{ user.realname }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="item.type == 4">
                    <div class="item-content-main">
                        <div class="content-main-head">
                            <div class="main-head-text" v-for="(user, index) in item.copy" :key="index">
                                <div class="user-box">
                                    <el-image class="avatar" :src="require('@/assets/img/logo_1024.png')"></el-image>
                                    <div>{{ user.realname }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'stepsLook',
    props: {
        stepList: {
            type: Array,
            default: []
        },
        moreBtn: {
            type: Boolean,
            default() {
                return true;
            }
        }
    },
    data() {
        return {
            status: {
                0: {
                    title: '待审核',
                    color: '#999'
                },
                1: {
                    title: '审核通过',
                    color: '#409EFF'
                },
                2: {
                    title: '审核驳回',
                    color: 'red'
                },
                3: {
                    title: '已转交',
                    color: '#999'
                },
                13: {
                    title: '已撤销',
                    color: '#999'
                }
            }
        };
    },
    methods: {}
};
</script>

<style lang="less">
.confirm-step-box {
    display: flex;
    flex-flow: column;

    .confirm-item {
        position: relative;
        padding: 0 10px;
        display: flex;
        flex-shrink: 1;

        .confirm-item-head {
            position: relative;
            flex-grow: 0;

            .confirm-item-head-line {
                position: absolute;
                width: 2px;
                top: 2px;
                bottom: 0;
                left: 15px;
                border-color: inherit;
                background-color: #c0c4cc;
            }

            .confirm-item-head-text {
                position: relative;
                z-index: 1;
                display: inline-flex;
                justify-content: center;
                align-items: center;
                width: 30px;
                height: 24px;
                box-sizing: border-box;
                background: #fff;
                font-size: 12px;

                .confirm-item-head-img {
                    height: 30px;
                }
            }
        }

        .confirm-item-content {
            padding-left: 10px;
            padding-bottom: 20px;
            white-space: normal;
            flex: 1;
            flex-grow: 1;
            text-align: left;

            .item-content-head {
                padding-bottom: 3px;
                display: flex;
                cursor: pointer;

                .item-content-head-text {
                    width: 8rem;
                    line-height: 24px;
                    font-size: 14px;
                    color: #333;
                }

                .item-content-head-more {
                    flex: 1;
                    text-align: end;
                }
            }
        }

        .item-content-main {
            .user-content {
                font-size: 12px;
                color: #333;
            }

            .content-main-head {
                display: flex;
                align-items: center;
            }

            .comment-box {
                padding: 8px 0;
                font-size: 12px;
                border-top: 1px solid #ebedf0;

                .comment-head {
                    display: flex;
                    justify-content: space-between;

                    .comment-head-title {
                        span {
                            color: #409eff;
                        }
                    }

                    .comment-head-more {
                    }
                }

                .comment-head-content {
                    padding: 8px 0;
                }

                .comment-image-box {
                    .comment-image {
                        width: 40px;
                        height: 40px;
                    }

                    .comment-image + .comment-image {
                        margin-left: 5px;
                    }
                }
            }

            .main-head-text {
                flex: 0 25%;
                line-height: 24px;
                font-size: 14px;
                color: #333;

                .user-box {
                    text-align: left;
                    font-size: 12px;

                    .avatar {
                        width: 30px;
                        height: 30px;
                    }
                }
            }

            .main-head-more {
                flex: 1;
                text-align: end;
                font-size: 12px;
            }
        }
    }
}
</style>
